// extracted by mini-css-extract-plugin
export default {"emoji-picker":"styles_emoji-picker__IG9nF","emoji-picker__button":"styles_emoji-picker__button__hJlK6","active":"styles_active__L5s80"};